
import {
  GAME_COINFLIP_ACTIVE,
  GAME_COINFLIP_NEW,
  GAME_COINFLIP_JOINING,
  GAME_COINFLIP_REOPEN,
  GAME_COINFLIP_JOINED,
  GAME_COINFLIP_LOCK,
  GAME_COINFLIP_ROLL,
  GAME_COINFLIP_EXPIRED,
} from '@/utils/constants/socket-events'

import CoinflipGame, { MARK_ROLLED_AFTER } from '@/store/models/games/coinflip/CoinflipGame'
import { GAME_STATUS } from '@/views/games/Coinflip/utils'

export default {
  [`SOCKET_${GAME_COINFLIP_ACTIVE}`]({ commit }, games) {
    CoinflipGame.create({
      data: games.map(data => {
        const game = { ...data }

        // remove server-client clock desync
        if (game.lockingAtDifferenceMs) {
          game.lockingAt = Date.now() + game.lockingAtDifferenceMs
        }

        if (game.rolledAtDifferenceMs) {
          game.rolledAt = Date.now() + game.rolledAtDifferenceMs
        }

        return game
      }),
    })
  },
  [`SOCKET_${GAME_COINFLIP_NEW}`]({ commit }, game) {
    CoinflipGame.insert({ data: game })
  },
  [`SOCKET_${GAME_COINFLIP_JOINING}`]({ commit }, { id, players }) {
    CoinflipGame.update({
      where: id,
      data: {
        players,
      },
    })
  },
  [`SOCKET_${GAME_COINFLIP_REOPEN}`]({ commit }, { id, players, status }) {
    CoinflipGame.update({
      where: id,
      data: {
        players,
        status,
      },
    })
  },
  [`SOCKET_${GAME_COINFLIP_JOINED}`]({ commit }, { id, status }) {
    CoinflipGame.update({
      where: id,
      data(record) {
        record.status = status
      },
    })
  },
  [`SOCKET_${GAME_COINFLIP_LOCK}`]({ commit, rootGetters }, { id, fairness }) {
    const conga = rootGetters['conga/conga']
    const { time } = conga.games.coinflip

    CoinflipGame.update({
      where: id,
      data(record) {
        record.status = GAME_STATUS.locked
        record.fairness = fairness
        record.lockingAt = Date.now() + time.countdown
        record.lockingAtDifferenceMs = time.countdown
      },
    })
  },
  [`SOCKET_${GAME_COINFLIP_ROLL}`]({ commit }, game) {
    CoinflipGame.update({
      where: game.id,
      data(record) {
        record.status = GAME_STATUS.complete // TODO
        record.fairness = game.fairness
        record.outcome = game.outcome
        record.rakedItems = game.rakedItems
        record.rolledAt = new Date().toISOString()
        record.rolledAtDifferenceMs = 0
        record.data = game.data
      },
    })

    // trigger an update after
    setTimeout(() => {
      CoinflipGame.update({ where: game.id, data: {} })
    }, MARK_ROLLED_AFTER)
  },
  [`SOCKET_${GAME_COINFLIP_EXPIRED}`]({ commit }, ids) {
    CoinflipGame.delete(game => ids.includes(game.id))
  },
}
